<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="addproduct()"
            v-b-tooltip.hover
            title="input data product baru"
          >
            <i class="fa fa-file"></i> Add
          </button>
          <button
            class="btn btn-warning mr-1"
            @click="editproduct()"
            v-b-tooltip.hover
            title="edit data product baru"
          >
            <i class="fa fa-pencil"></i> Edit
          </button>
          <!-- <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button> -->

          <!-- <button
            class="btn btn-primary mr-1"
            @click="importKRK()"
            v-b-tooltip.hover
            title="Import data pinjaman model berjangka/PRK (tanpa Angsuran bulanan)"
          >
            <i class="fa fa-upload"></i> Import PRK
          </button>
          <button
            class="btn btn-primary mr-1"
            @click="importJaminan()"
            v-b-tooltip.hover
            title="Import data Jaminan"
          >
            <i class="fa fa-upload"></i> Import Jaminan
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>-->
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Issued Item</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.uraian" placeholder="Name/Description"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Issued Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text">-</span>
            </b-input-group-append>
            <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Store/Warehouse</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.outletname" readonly></b-form-input>
            <!-- <b-form-select v-model="tblData.idStore" :plain="true" :options="dataList.warehouse"></b-form-select> -->
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Item Category</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.nmcategory" placeholder="Category"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(tanggal)="data">{{ data.item.tanggal | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import invout from "../../apis/logistic_inv_out";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import produkkredit from "../../apis/produkkredit";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "prodcode",
        sortDesc: false
      },
      model: {}
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "prodcode",
          label: "Product Code",
          sortable: true
        },
        {
          key: "prodname",
          label: "Product Name",
          sortable: true
        },
        {
          key: "prodofferingcode",
          label: "Prod. Offering Code",
          sortable: true
        },
        {
          key: "prodofferingname",
          label: "Prod. Offering Name",
          sortable: true
        },
        // {
        //   key: "description",
        //   label: "Description",
        //   sortable: true
        // },
        {
          key: "createby",
          label: "Issued By",
          sortable: true
        }
      ];
      return fields;
    }
  },
  methods: {
    async addproduct() {
      router.push({ name: "loan.master-product-form" });
    },
    async editproduct() {
      console.log(this.model);
      try {
        if (this.model.productkey) {
          const productkey = this.model.productkey;
          router.push({
            name: "loan.master-product-form",
            params: { productkey }
          });
        } else {
          toastr.warn("Please select a row that want to be Edit!");
        }
      } catch (error) {
        console.log("error : ", error);
        // this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    data: async function() {
      try {
        const list = await produkkredit.list(this.tblData);
        return list;
      } catch (error) {
        console.log("error : ", error);
        // this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    close() {}
  }
};
</script>
      
      <style>
</style>